import { User } from "../types/types";
import {
  getAgentProfileRoute,
  getCoachProfileRoute,
  getEntityProfileRoute,
  getOtherProfileRoute,
  getPlayerProfileRoute,
  getScoutProfileRoute,
} from "../routers/routeUtils";

export const getProfileLink = (user: Partial<User>): string => {
  if (!user.id) return "";

  // Check if user has an entity
  if (user.entity) {
    return getEntityProfileRoute(user.entity.id) || "";
  }

  // Handle regular user roles
  switch (user.role) {
    case "PLAYER":
      return getPlayerProfileRoute(user.id);
    case "AGENT":
      return getAgentProfileRoute(user.id);
    case "SCOUT":
      return getScoutProfileRoute(user.id);
    case "COACH":
      return getCoachProfileRoute(user.id);
    default:
      return getOtherProfileRoute(user.id);
  }
};
